module.exports = __webpack_public_path__ + "static/scale-model-of-w&od-trailhead-in-alexandria-virginia-a6d570beb60627c5f51f70b6adc0a227.png";